import { FunctionalComponent, h } from 'preact';

import { i18nTranslate } from 'common/helper/i18n/translate';
import { DropdownComponent } from 'common/module/dropdown/component';
import { MyAccountListTypeEnum } from 'common/module/my-account/list-type.enum';
import { MyAccountHeaderTemplatePropsInterface } from 'desktop/module/my-account/header/template-props.interface';

export const MyAccountHeaderTemplate: FunctionalComponent<MyAccountHeaderTemplatePropsInterface> = (props) => {
  const showFilters = props.listType !== MyAccountListTypeEnum.searches;

  return (
    <div className='my-account-header__field-area'>
      {showFilters && (
        <div className='my-account-header__category'>
          <div className='my-account-header__label'>{i18nTranslate('Category')}:</div>
          <div className='my-account-header__field'>
            <DropdownComponent
              class='dropdown--bordered my-account-header__dropdown'
              options={props.categoryOptions}
              placeholder={i18nTranslate('Category')}
              value={props.categoryValue}
              onChange={(value: string) => props.onChangeCategoryDropdown(value)}
            />
          </div>
        </div>
      )}

      {props.showDeleteAll && (
        <div className='button my-account-header__delete' onClick={(e) => props.onClickDeleteAll(e)}>
          <span
            className='svg'
            dangerouslySetInnerHTML={{
              __html: `
        <svg viewBox='0 0 10 12' class='my-account-header__delete-icon'>
          <use xlink:href="#svg-trash"></use>
        </svg>
      `,
            }}
          />
          <span>{i18nTranslate('Delete all')}</span>
        </div>
      )}

      {showFilters && (
        <div className='my-account-header__sort'>
          <div className='my-account-header__label'>{i18nTranslate('Sort by')}:</div>
          <div className='my-account-header__field'>
            <DropdownComponent
              class='dropdown--bordered my-account-header__dropdown'
              options={props.sortOptions}
              placeholder={i18nTranslate('Sort')}
              value={props.sortValue}
              onChange={(value: string) => props.onChangeSortByDropdown(value)}
            />
          </div>
        </div>
      )}
    </div>
  );
};
